import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    pageId: String,
  };

  toggle() {
    const containerId = `images-container-${this.pageIdValue}`;
    const existing = document.getElementById(containerId);

    if (existing) {
      existing.classList.toggle("hidden");
      return;
    }

    this.fetchAndShowImages();
  }

  async fetchAndShowImages() {
    try {
      const response = await fetch(`/extracted_pages/${this.pageIdValue}/images`, {
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      this.renderImages(data.images);
    } catch (error) {
      console.error("Failed to fetch images:", error);
    }
  }

  renderImages(images) {
    const pageRow = this.element.closest("tr");

    const container = document.createElement("tr");
    container.id = `images-container-${this.pageIdValue}`;

    if (!images || images.length === 0) {
      container.innerHTML = `
        <td colspan="4" class="px-6 py-4 bg-gray-50 text-sm text-gray-400 text-center">
          No images for this page.
        </td>
      `;
    } else {
      const imgTags = images
        .map(
          ({ filename, url }) => `
          <a href="${url}" target="_blank" class="block group">
            <img src="${url}"
                 alt="${filename}"
                 class="max-h-64 rounded border border-gray-200 shadow-sm group-hover:opacity-90 transition-opacity"
                 loading="lazy">
            <span class="text-xs text-gray-400 mt-1 block">${filename}</span>
          </a>
        `,
        )
        .join("");

      container.innerHTML = `
        <td colspan="4" class="px-6 py-4 bg-gray-50">
          <div class="flex flex-wrap gap-4">
            ${imgTags}
          </div>
        </td>
      `;
    }

    pageRow.insertAdjacentElement("afterend", container);
  }
}
